/**
 * AssessmentStatsCards Component
 * Displays statistics cards for assessments
 * Extracted from Assessments.js for better code organization
 */
import { Card } from '../ui/card';
import { Brain, CheckCircle, AlertCircle, Users, BarChart3 } from 'lucide-react';

const StatCard = ({ icon: Icon, iconBgColor, iconColor, label, value, cardClass = '' }) => (
  <Card className={`p-6 ${cardClass}`}>
    <div className="flex items-center gap-3">
      <div className={`${iconBgColor} p-3 rounded-lg`}>
        <Icon size={24} className={iconColor} />
      </div>
      <div>
        <p className="text-xs font-bold uppercase text-slate-500">{label}</p>
        <p className={`text-2xl font-bold ${iconColor.includes('red') ? 'text-red-600' : ''}`}>{value}</p>
      </div>
    </div>
  </Card>
);

const AssessmentStatsCards = ({ 
  totalCount, 
  activeCount, 
  expiredCount, 
  totalSent, 
  totalResponses 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-testid="assessment-stats">
      <StatCard
        icon={Brain}
        iconBgColor="bg-purple-100 dark:bg-purple-900"
        iconColor="text-purple-600"
        label="Total"
        value={totalCount}
      />
      <StatCard
        icon={CheckCircle}
        iconBgColor="bg-emerald-100 dark:bg-emerald-900"
        iconColor="text-emerald-600"
        label="Ativas"
        value={activeCount}
      />
      <StatCard
        icon={AlertCircle}
        iconBgColor="bg-red-100 dark:bg-red-900"
        iconColor="text-red-600"
        label="Vencidas"
        value={expiredCount}
        cardClass="border-red-200 dark:border-red-800"
      />
      <StatCard
        icon={Users}
        iconBgColor="bg-blue-100 dark:bg-blue-900"
        iconColor="text-blue-600"
        label="Enviadas"
        value={totalSent}
      />
      <StatCard
        icon={BarChart3}
        iconBgColor="bg-yellow-100 dark:bg-yellow-900"
        iconColor="text-yellow-600"
        label="Respostas"
        value={totalResponses}
      />
    </div>
  );
};

export default AssessmentStatsCards;
